'use client';

import TraderDetailPageMobile from "@/components/trader/TraderMobile";
import TraderDetailPagePC from "@/components/trader/TraderPC";

export default function TraderDetailPage() {
  // Logic for app download - detect platform and redirect to appropriate store
  const userAgent = navigator.userAgent;

  // Desktop - show both options or default to iOS App Store
  const isMobile =
    /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );

  return isMobile ? <TraderDetailPageMobile /> : <TraderDetailPagePC />;
}
